import "./css/Header.css";

import { Link } from "react-router-dom";

import { ButtonPrimary } from "../../../components/Buttons";

import { IoMdMenu } from "react-icons/io";
import useToggleRender from "../../../hooks/useToggleRender";
import LandingMenu from "./LandingMenu";
import Backdrop from "../../../components/Modals/Backdrop";

function Header() {
  const {
    active: menuActive,
    mounted: menuMounted,
    transitionClass: menuTransitionClass,
    activate: openMenuHandler,
    deactivate: closeMenuHandler,
  } = useToggleRender({ enterDuration: 300 });

  return (
    <header className="landing-header">
      <div className="header-container landing-container">
        <div className="left">
          <ButtonPrimary
            iconStart={<IoMdMenu />}
            variant={"icon"}
            style={{ border: "none", background: "none" }}
            className="landing-menu-btn"
            onClick={openMenuHandler}
          />
          <Link to="/welcome" className="logo">
            <span>Physio</span>
            <span>Track</span>
          </Link>
        </div>
        <div className="right">
          <nav>
            <Link to="/welcome">Home</Link>
            <Link to="/about-us">About</Link>
            <Link to="/contact-us">Contact us</Link>
            <Link to="/login">Login</Link>
            <Link to="/sign-up" className="signup">
              Sign up
            </Link>
          </nav>
        </div>
      </div>
      {menuMounted && (
        <LandingMenu
          closeMenuHandler={closeMenuHandler}
          className={menuTransitionClass}
        />
      )}
      {menuActive && <Backdrop />}
    </header>
  );
}

export default Header;
